interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_MAP = {
  sm: { block: 28, monogram: 11, line1: 11, line2: 0 },
  md: { block: 36, monogram: 14, line1: 13, line2: 9 },
  lg: { block: 52, monogram: 20, line1: 18, line2: 12 },
} as const;

export function Logo({ size = 'md' }: LogoProps): JSX.Element {
  const dims = SIZE_MAP[size];
  const showFahrtenplaner = size !== 'sm';

  return (
    <div className="flex items-center gap-3" aria-label="H&R Handel Fahrtenplaner">
      <div
        className="flex items-center justify-center rounded-md bg-brand-ink text-white font-semibold"
        style={{
          width: dims.block,
          height: dims.block,
          fontSize: dims.monogram,
          letterSpacing: 0.5,
        }}
      >
        H&amp;R
      </div>
      <div className="h-8 w-px bg-brand-line" aria-hidden="true" />
      <div className="flex flex-col leading-tight">
        <span
          className="font-medium text-brand-ink"
          style={{ fontSize: dims.line1, letterSpacing: '0.15em' }}
        >
          HANDEL
        </span>
        {showFahrtenplaner && (
          <span
            className="font-light text-brand-muted"
            style={{ fontSize: dims.line2, letterSpacing: '0.25em' }}
          >
            FAHRTENPLANER
          </span>
        )}
      </div>
    </div>
  );
}
